export default __webpack_public_path__ + "imgs/beTogether.7ec308e.jpeg";